import { useQuery } from '@tanstack/react-query';

import { getAvailableColumns } from '../api/reports.api';
import { REPORT_AVAILABLE_COLUMNS_QUERY_KEY } from '../constants/reports-query-keys';

export const useAvailableColumns = (reportType: string | null) => {
  return useQuery({
    queryKey: REPORT_AVAILABLE_COLUMNS_QUERY_KEY(reportType),
    queryFn: () => getAvailableColumns(reportType as string),
    staleTime: 10 * 60 * 1000,
    enabled: !!reportType,
  });
};
